<template>
	<div class="panel_sale">
		<saleTable></saleTable>
		<div class="settlementBox">
			<saleSettlement></saleSettlement>
		</div>
	</div>
</template>
<script>
	import saleTable from "./comp/sale_table.vue"
	import saleSettlement from "./comp/sale_settlement.vue"
	export default {
		components:{saleTable,saleSettlement},
		data(){
			return{
				
			}
		},
		mounted(){
			this.$store.dispatch("mendian/get_unPayOrderList")
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	background-color: #fff;
	.settlementBox{
		position: absolute;
		bottom:0;
		width:100%;
	}
}
</style>
